module.exports = __webpack_public_path__ + "img/exclamation.36a823e8.svg";